<template>
    <div v-if="authedUser.isadmin==false && authedUser.isadmin!=null" class="users">
        <h4>Your Quote Items  <b-button size="sm" variant="danger" class="float-right" @click="finalizequote()"> Finalize Quote</b-button> <b-button size="sm" variant="primary" class="mr-3 float-right" @click="customview=true">  <span class="fa fa-plus"></span> Custom Requests</b-button></h4>
        <div v-if="customview==true">
            <b-row class="d-md-flex d-block mt-md-5">
                <b-col cols="12" md="3">
                    <b-input v-model="customitem.quantity" placeholder="Item Quantity"></b-input>

                </b-col>
                <b-col cols="col-12" md="3">
                    <b-input v-model="customitem.description" placeholder="Item Description" ></b-input>
                </b-col>
                <b-col cols="col-12" md="3" style="align-self:center">
                    <b-button @click="fillcustoms()" size="sm" variant="primary">
                        Add
                    </b-button>
                    <b-button @click="customview=false" size="sm" class="ml-2" variant="primary">
                        Cancel
                    </b-button>
                </b-col>
                <b-col></b-col>
            </b-row>
        </div>
        <div class="mt-2" v-if="noncustomquotes.length>0">
            <h5>Quoted Items</h5>
            <b-table :responsive="true" :fields="getQuoteFields" striped hover :items="noncustomquotes">
                 <template v-slot:head(iscustomrequest)="">
                    Request Type
                </template>
                <template v-slot:cell(saleprice)="data">
                    <!-- {{data.item}} -->
                        €{{getPrice(data.item.inventoryitemid).saleprice}}
                 </template> 
                 <template v-slot:cell(subtotal)="data">
                        €{{getPrice(data.item.inventoryitemid).saleprice* parseInt(data.item.quantity)}}
                 </template> 
                 <template v-slot:cell(iscustomrequest)="data">
                    <b-badge  :variant="data.item.iscustomrequest==true ? 'success':'danger'">{{data.item.iscustomrequest==true ? 'Custom':'Non Custom'}}</b-badge>

                 </template> 
                <template v-slot:cell(action)="data">
                    <b-button size="sm" variant="danger" class="fas fa-trash" @click="removeItem(data.item)">  </b-button>
                </template>
            </b-table>
        </div>
        <div class="mt-2" v-if="customquotes.length>0">
            <h5>Requested Items</h5>
            <b-table  :responsive="true" striped hover :fields="customfields" :items="customquotes">
                
                <template v-slot:cell(action)="data">
                    <b-button size="sm" variant="danger" class="fas fa-trash" @click="removeCustomItem(data.inventoryitemid)">  </b-button>
                </template>
            </b-table>
        </div>
        <div v-else>
            No Items
        </div>
        <h4 class="mt-4">Search Filters</h4>
       <b-row>
           <b-col cols="12" md="3">
               Search
               <b-input v-model="search_name" type="text" placeholder="Search by sku vcode/description"></b-input>
           </b-col>
            <b-col cols="12" md="3">
                Categories
               <select name="" v-model="category_filter" class="form-control" @change="handleChange" id="">
                   <option v-for="(item,i) in categories" :key="i" :value="item.id">{{item.name}}</option>
               </select>
           </b-col>
           <b-col v-if="subcats.length>0" cols="12" md="3">
                Sub Categories
               <select name="" class="form-control" v-model="subcat_filter" id="">
                   <option v-for="(item,i) in subcats" :key="i" :value="item.id">{{item.name}}</option>
               </select>
           </b-col>
           <b-col cols="12" md="3" style="align-self:center;" class="mt-3">
               <!-- <b-button variant="primary" @click="search_filters()">Filter</b-button> -->
                <b-button class="ml-2" variant="primary" @click="search_name='';category_filter='';subcat_filter=''">Clear</b-button>

           </b-col>
       </b-row>
                   <!-- {{categories}} -->

       <b-row v-if="fillInventoryItems.length>0" class="mt-3">
           <div class="col-md-12" v-for="(item,i) in fillInventoryItems" :key="i">
               <h4>{{item.categoryname}}</h4>
               <div v-for="(subitem,j) in item.sub_arr" :key="j">
                   <h5>{{subitem.subcatname}}</h5>
                    <b-table :responsive="true"  striped hover :fields="getFields" :items="subitem.subitems">
                        <template v-slot:head(iscustomrequest)="">
                            Request Type
                        </template>
                        <template v-slot:cell(description)="data">
                           
                           <span v-if="i%8!=0"  v-for="(opds,i) in data.item.description.split(' ')" :key="i">
                               {{opds}}

                           </span>
                           <br v-else>

                        </template> 
                        <template v-slot:cell(saleprice)="data">
                            {{data.item.saleprice}}€
                        </template> 
                        <template v-slot:cell(discountprice)="data">
                            {{data.item.saleprice}}€
                        </template> 
                        <template v-slot:cell(select_quantity)="data">
                            <div class="d-flex  ">
                                <!-- float-right -->
                            <b-input placeholder="Quantity" type="number" min="1" v-model="data.item.quantity" class="col-md-6"></b-input>
                            <b-button variant="primary" size="sm" block @click="fillQuote(data.item)" class="col-md-2"><span class="fa fa-plus"></span> </b-button>
                            </div>
                        </template> 
                        <template v-slot:cell(iscustomrequest)="data">
                            <b-badge  :variant="data.item.iscustomrequest==true ? 'success':'danger'">{{data.item.iscustomrequest==true ? 'Custom':'Non Custom'}}</b-badge>
                        </template> 
                    </b-table>
               </div>

        </div>
       </b-row>
       <b-row class="mt-3" v-else>
           <b-col>
               <h5>No search results of this criteria</h5>
           </b-col>
       </b-row>

        <a-modal
            title="Final Quote Details"
            :visible="visible"
            :footer="null"
            @cancel="handleCancel"
            >
            
            <div class="row">
                <div class="col-md-6 col-12">
                    <label for="username"><strong>Delivery Location + Address</strong>:  </label>
                    <b-input v-model="new_quote.loadingport"></b-input>
                </div>
                <div class="col-md-6 col-12">
                    <label for="email"><strong>Delivery needed by</strong>:</label>
                    <b-input type="date" v-model="new_quote.eta"></b-input>

                </div>
            </div>
            <!-- <div class="row mt-3">
                <div class="col-md-6 col-12">
                    <label for="role"><strong>Contact1</strong>: {{selecteduser.contact1}}</label>
                   
                </div>
                <div class="col-md-6 col-12">
                    <label for="password"><strong>Contact2</strong>: {{selecteduser.contact2}}</label>
                </div>
            </div> -->
            <div class="row mt-3">
                <div class="col-md-12">
                    <button class="btn btn-primary btn-block" @click="handleConfirm">Confirm</button>
                </div>
            </div>
        </a-modal>

       
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import moment from 'moment'
import { RepositoryFactory } from '../../Repository/RepositoryFactory'
const QuoteRepository = RepositoryFactory.get('quote_repository')
export default {
    name: "UserItems",
    computed:{
        ...mapGetters(['customers','categories','viewinventoryitems','subcategories','authedUser','autoids']),
        customquotes(){
            return this.quotes.filter(item=>item.iscustomrequest==true)
        },
        getQuoteFields(){
            if(this.authedUser.showprices=='none') {
                return this.quotedfields
            }
            else{
                return this.fields

            }
        },
        getFields(){
            if(this.authedUser.showprices=='none'){
                return this.viewfields
            }
            else if(this.authedUser.showprices=='sale'){
                return this.regularviewfields 

            }
            else if(this.authedUser.showprices=='sale & discount'){
                return this.regulardiscountviewfields
            }
             
        },
        noncustomquotes(){
            return this.quotes.filter(item=>item.iscustomrequest==false)
        },
        subcats(){
           return this.subcategories.filter(item=>item.categoryid==this.selectedcatid)

        },
        fillInventoryItems(){
         this.tempitems=[]
         if(this.category_filter==''){   
         this.categories.forEach(item=>{
            let subcats=this.getAllSubcats(item.id)
            let sub_arr=[]
            subcats.forEach(subitem=>{
               if(this.search_name!=''){
                    const pureitems = this.viewinventoryitems.filter(invitem=> invitem.categoryid==item.id && invitem.subcategoryid==subitem.id)
                    let pc=[]
                    if(pureitems.length>0){
                        pc=pureitems.filter(invitem=>invitem.description.toLowerCase().includes(this.search_name.toLowerCase()) || invitem.sku_vcode.toLowerCase().includes(this.search_name.toLowerCase()))  
                    }
                    if(pc.length>0){ 
                        sub_arr.push({subcatname:subitem.name,subitems:pc})
                    }
               } 
               else{
                    let pureitems = this.viewinventoryitems.filter(invitem=>invitem.categoryid==item.id && invitem.subcategoryid==subitem.id)
                    if(pureitems.length>0){ 
                        sub_arr.push({subcatname:subitem.name,subitems:pureitems})
                    }
               }
            })
            if(sub_arr.length>0){
                this.tempitems.push({sub_arr:sub_arr,categoryname:item.name})
            }
          
         })
         }
         else{
             if(this.subcat_filter==''){
            let subcats=this.getAllSubcats(this.category_filter)
            
            let sub_arr=[]
            subcats.forEach(subitem=>{
               if(this.search_name!=''){
                    const pureitems = this.viewinventoryitems.filter(invitem=>invitem.categoryid==this.category_filter && invitem.subcategoryid==subitem.id)
                    let pc=[]
                    if(pureitems.length>0){
                        pc=pureitems.filter(invitem=>invitem.description.toLowerCase().includes(this.search_name.toLowerCase()) || invitem.sku_vcode.toLowerCase().includes(this.search_name.toLowerCase()))  
                       
                    }
                    if(pc.length>0){ 
                        sub_arr.push({subcatname:subitem.name,subitems:pc})
                    }
               } 
               else{
                      let pureitems = this.viewinventoryitems.filter(invitem=>invitem.categoryid==this.category_filter && invitem.subcategoryid==subitem.id)
                        if(pureitems.length>0){ 
                            sub_arr.push({subcatname:subitem.name,subitems:pureitems})
                        }     
                    
               }
            })
            // Confustion here
            if(sub_arr.length>0){
                this.tempitems.push({sub_arr:sub_arr,categoryname:this.getCategory(this.category_filter).name})
            }
          }
          else{
             let obj=this.getSubCategory(this.subcat_filter)
            let pureitems = this.viewinventoryitems.filter(invitem=>invitem.categoryid==this.category_filter && invitem.subcategoryid==this.subcat_filter)
            let sub_arr=[]
            sub_arr.push({subcatname:obj.name,subitems:pureitems})
            this.tempitems.push({sub_arr:sub_arr,categoryname:this.getCategory(this.category_filter).name})


          }  
          
         }
          return this.tempitems
        },

    },
    watch:{
        categories(){
            if(this.categories.length>0){
                this.selectedcatid=this.categories[0].id
            }
        },
        
    },
    data() {
      return {
          count:0,
        quoteObj:{
            personalizations: [
            {
            to: [
                {
                email: "info@lanemo.co"
                }
            ],
            dynamic_template_data: {
                total:'',
                contact: {
                    email: "",
                    phone: "",
                    vessel: "",
                    eta: ""
                },
                items: [],
                requests: []   
                },
                subject: "New Quote"
            }
        ],
            from: {
                email: "simon@basilisk.gg"
            },
            template_id:"d-be4671c16f6a4486a25c412d7f6f9624"
        },
          customview:false,
          quotes:[],
          quantity:'',
          subcat_filter:'',
          selectedcatid:'',
          customfields:[
              'description',
              'quantity',
              'action'

          ],
          quotedfields:[
              'sku_vcode',
              'quantity',
              'description',
              'action'
          ],
          fields:[
              'sku_vcode',
              'quantity',
              'saleprice',
              'subtotal',
              'description',
              'action'

          ],
          regulardiscountviewfields:[
              'sku_vcode',
              'description',
              'saleprice',
              'discountprice',
              'select_quantity'

          ],
          regularviewfields:[
              'sku_vcode',
              'description',
              'saleprice',
              'select_quantity'


          ],
          viewfields:[
              'sku_vcode',
              'description',
              'select_quantity'

          ],
            //   'action'

        customitem:{
            quantity:'',
            description:''
        },
        new_quote:{
            loadingport:'',
            eta:"",
            showid:'0',
            created:'',
            total:0,
            userid:''
        },
        new_quote_item:{
        created: '',
        description: '',
        inventoryitemid: '',
        iscustomrequest: false,
        name: '',
        quantity: '',
        quoteid: ''
       },  
        selecteduser:'',
        visible: false,
        search_name:'',
        category_filter:'',
        tempitems:[]

       
      };
    },
    created(){
    
    
        if(this.categories.length>0){
                this.selectedcatid=this.categories[0].id
                
        }
    },
    mounted(){
        if(this.categories.length>0){
                this.selectedcatid=this.categories[0].id
        }

    },
    methods: {
        
        async sendQuoteReport(){
           let resp =await QuoteRepository.quoteReport({reqobj:this.quoteObj})
           
        },
        handleConfirm(){
                this.quoteObj.personalizations[0].dynamic_template_data.contact={
                    email: this.authedUser.email,
                    phone: this.authedUser.contact1,
                    vessel: this.authedUser.vesselname,
                    eta: this.new_quote.eta
                }
                this.quoteObj.personalizations[0].dynamic_template_data.total=0
                this.quotes.forEach(item=>{
                    
                    if(item.iscustomrequest==true){
                        this.quoteObj.personalizations[0].dynamic_template_data.requests.push({
                            description: item.description,
                            quantity: item.quantity,
                        })
                    }
                    else{
                        let price=this.getPrice(item.inventoryitemid).saleprice
                        this.quoteObj.personalizations[0].dynamic_template_data.items.push({
                        vcode: item.sku_vcode,
                        description: item.description ,
                        quantity: item.quantity,
                        price: price,
                        subTotal: item.quantity*price+''
                        })
                        let subt= parseInt(item.quantity)* parseInt(price)
                        this.quoteObj.personalizations[0].dynamic_template_data.total=this.quoteObj.personalizations[0].dynamic_template_data.total+subt

                    }
                })

            if(this.new_quote.eta!='' && this.new_quote.loadingport!=''){
                    this.new_quote.total=0
                    this.new_quote.created=moment().format('DD-MM-YYYY HH:mm:ss')
                    this.new_quote.userid=this.authedUser.id
                    this.new_quote.showid=this.autoids.quotes+1
                    this.quotes.forEach(item=>{
                        this.new_quote.total=this.new_quote.total+ parseInt(item.quantity)
                    })   
                    this.$store.dispatch("newQuotes",{new_quote:this.new_quote,quotes:this.quotes})
                    this.$store.dispatch("updateAutoId",{quotes:this.autoids.quotes+1})
                    this.sendQuoteReport()
                    this.quotes=[]
                    this.new_quote={
                        loadingport:'',
                        eta:"",
                        showid:'0',
                        created:'',
                        total:0,
                        userid:''
                    }
                    this.visible=false


                   
            }
            else{
            this.$store.commit("setNotifications",{message:'Fill final quote details',type:'error'})

            }
        },
        getPrice(id){
           return  this.viewinventoryitems.find(item=>item.id==id)   
        },
        finalizequote(){

            if(this.quotes.length>0){
                this.visible=true
            }
            else{
            this.$store.commit("setNotifications",{message:'Select some items first please',type:'error'})

            }
        },
        removeItem(qitem){
            let index=this.quotes.findIndex(item=>item.id==qitem.id)
            this.quotes.splice(index,1)

        },
        removeCustomItem(id){
            let index=this.quotes.findIndex(item=>item.inventoryitemid==id)
            this.quotes.splice(index,1)

        },
        fillcustoms(){
            if(this.customitem.quantity!='' && this.customitem.description!=''){
                
                this.new_quote_item={
                    created: moment().format("DD-MM-YYYY HH:mm:ss"),
                    description: this.customitem.description,
                    iscustomrequest: true,
                    quantity: this.customitem.quantity,
                    inventoryitemid:this.count
                }
                this.count++
                this.quotes.push(this.new_quote_item)
                this.customitem={
                    quantity:'',
                    description:''
                }
            }
            else{
                this.$store.commit("setNotifications",{message:'Fill in all fields',type:'error'})

            }


        },
        fillQuote(qitem){
            if(qitem.quantity>0) {
                this.new_quote_item={
                    created: moment().format("DD-MM-YYYY HH:mm:ss"),
                    description: qitem.description,
                    inventoryitemid: qitem.id,
                    iscustomrequest: false,
                    sku_vcode: qitem.sku_vcode,
                    quantity: qitem.quantity,
                }
                let index=this.quotes.findIndex(item=>item.inventoryitemid==qitem.id)
                if(index!=-1){
                this.$set(this.quotes[index],'quantity',this.new_quote_item.quantity)
                }
                else{
                this.quotes.push(this.new_quote_item)
                }

            }
            else {
                this.$store.commit("setNotifications",{message:'Quantity should be greater then 0',type:'error'})
            }

        },
        getCategory(id){
           return this.categories.find(item=>item.id==id)
        },
        getAllSubcats(id){
           return this.subcategories.filter(item=>item.categoryid==id) 
            
        },
        getSubCategory(id){
           let obj=this.subcategories.find(item=>item.id==id) 
           return obj!=null ? obj :''
        },
        handleChange(e){
            this.selectedcatid=e.target.value

        },
        
    
      handleCancel(e) {
        this.visible = false;
      },
    
    }
}
</script>
